import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ToastModule, ToastOptions } from 'ng2-toastr/ng2-toastr';
import { AngularDraggableModule } from 'angular2-draggable';
import { ColorPickerModule } from 'ngx-color-picker';

import { CtRoutingModule } from './ct-routing.module';
import { AppComponent } from './app.component';
import { DataService } from './shared/data.service';
import { FieldComponent } from './field/field.component';
import { CustomToastOptions } from './shared/custom-toast-options';
import { WindowRef } from './shared/window-ref';
import { SetSizeToDirective } from './shared/set-size-to.directive';

import {EditorModule} from 'primeng/primeng';

@NgModule({
    declarations: [
        AppComponent,
        FieldComponent,
        SetSizeToDirective
    ],
    imports: [
        BrowserModule,
        HttpModule,
        FormsModule,
        BrowserAnimationsModule,
        ColorPickerModule,
        ToastModule.forRoot(),
        AngularDraggableModule,
        CtRoutingModule,
        EditorModule
    ],
    providers: [
        DataService,
        { provide: ToastOptions, useClass: CustomToastOptions },
        WindowRef
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/app.module.ts